import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogSelect, Pageheader } from './pageheader.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    Pageheader,
    DialogSelect
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule

  ],
  exports: [
    Pageheader
  ]
})
export class PageHeaderModule {
}
